"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var icon_1 = __importDefault(require("../../atoms/icon"));
var navigation_item_1 = __importDefault(require("./navigation-item"));
var tokens_1 = require("../../tokens");
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var passSubMenuPropToChildren = function (children) {
    return React.Children.map(children, function (el) {
        if (!el) {
            return null;
        }
        return React.cloneElement(el, { inSubMenu: true });
    });
};
var NavigationSubnav = function (props) {
    var children = props.children, open = props.open;
    return (React.createElement(NavigationSubnav.Content, __assign({}, automation_attribute_1.default('navigation.link-group'), { open: open, hidden: !open }), passSubMenuPropToChildren(children)));
};
NavigationSubnav.Content = styled_1.default.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: 1 0 100%;\n  margin-left: calc(18px + ", ");\n  overflow: hidden;\n  max-height: ", ";\n  visibility: ", ";\n  transition: all 0.3s ease-in-out;\n\n  ", " {\n    a {\n      padding-top: ", ";\n      padding-bottom: ", ";\n    }\n  }\n  ", " svg {\n    width: 16px;\n    height: 16px;\n  }\n"], ["\n  flex: 1 0 100%;\n  margin-left: calc(18px + ", ");\n  overflow: hidden;\n  max-height: ", ";\n  visibility: ", ";\n  transition: all 0.3s ease-in-out;\n\n  ", " {\n    a {\n      padding-top: ", ";\n      padding-bottom: ", ";\n    }\n  }\n  ", " svg {\n    width: 16px;\n    height: 16px;\n  }\n"])), tokens_1.spacing.xsmall, function (props) { return (props.open ? props.children.length * 50 + 'px' : '0'); }, function (props) { return (props.open ? 'visible' : 'hidden'); }, navigation_item_1.default, tokens_1.spacing.xxsmall, tokens_1.spacing.xxsmall, icon_1.default.Element);
NavigationSubnav.defaultProps = {};
exports.default = NavigationSubnav;
var templateObject_1;
//# sourceMappingURL=navigation-subnav.js.map